import request from '@/utils/request';

/**
 * 复制装修页面
 */
export function copyDesignApi(params) {
  return request({
    url: "/admin/company-design/copyDesign",
    method: 'GET',
    params: params
  });
}

/**
 * 列表的删除
 */
export function deleteApi(params) {
  return request({
    url: "/admin/company-design/delete",
    method: 'GET',
    params: params
  });
}

/**
 * 列表的禁用
 */
export function disableApi(params) {
  return request({
    url: "/admin/company-design/disable",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理引用的删除
 */
export function manageDeleteApi(params) {
  return request({
    url: "/admin/company-design/removeRelate",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理引用
 */
export function manageRelateApi(data) {
  return request({
    url: "/admin/company-design/manageRelate",
    method: 'POST',
    data: data
  });
}

/**
 * 小程序列表自动补全
 */
export function companyappAutoListApi(params) {
  return request({
    url: "/admin/companyapp/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 装修管理列表
 */
export function companyDesignListApi(params) {
  return request({
    url: "/admin/company-design/list",
    method: 'GET',
    params: params
  });
}

/**
 * 查询客户下拉列表
 * @param {*} id
 * @returns
 */
export function customersListApi(params) {
  return request({
    url: "/admin/customers/options",
    method: 'GET',
    params: params
  });
}

/**
 * 详情
 */
export function getDetailApi(params) {
  return request({
    url: '/admin/company-design/getDetail',
    method: 'GET',
    params: params
  });
}